const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const userApi = {
    loginApi: async (values) => {
        try {
            const response = await fetch(`${apiBaseUrl}/users/signinV2`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user: { email: values.email, password: values.password }
                }),
                credentials: 'include',
            });

            const responseJson = await response.json();
            return responseJson;


        } catch (error) {
            throw new Error(error.message);
        }
    },

}
// const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

// export const userApi = {
//     loginApi: async (values) => {
//         try {
//             fetch(`${apiBaseUrl}/users/signinV2`, {
//                 method: 'POST',
//                 headers: {
//                     Accept: 'application/json',
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     user: { email: values.email, password: values.password}
//                 }),
//                 credentials: 'include',
//             }).then(response => {
//                 if (response.ok) {
//                     response.json().then(responseJson =>{
//                         return responseJson
//                     })
//                 }
//             })

//         } catch (error) {
//             // console.error('Error creating inventory:', error.message);
//             throw new Error(error.message);
//         }
//     },

// }